import React, {useRef, useState} from "react";
import {
    IonButton,
    IonContent,
    IonHeader, IonItem,
    IonPage, IonTextarea,
    IonTitle, IonToolbar
} from "@ionic/react";

const ModalNote = ({dismiss}: { dismiss: (data?: string | null | undefined, role?: string) => void}) => {

    const [note, setNote] = useState<string | null | undefined>(undefined);
    const modal = useRef<HTMLIonModalElement>(null);

    return (
        <IonPage ref={modal}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Add Note</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">

                <p>Enter in the note below:</p>
                <IonTextarea fill="outline" value={note} rows={10} onIonChange={(e) => setNote(e.detail.value)}></IonTextarea>


                <p style={{textAlign: 'right'}}>
                    <IonButton onClick={() => dismiss(null, 'cancel')} fill="outline">Cancel</IonButton>
                    <IonButton strong={true} onClick={() => dismiss(note, 'confirm')}>
                        Confirm
                    </IonButton>
                </p>
            </IonContent>
        </IonPage>);
};

export default ModalNote;